/* eslint-disable jsx-a11y/anchor-is-valid */

import "./Style.css";
import {useLocation} from "react-router-dom";
import HeaderNav from "../navbar/HeaderNav";

function Header() {
   const location = useLocation();
  

  return (
    <>
    <div className={`${location.pathname !=="/" ? "bg-primary" : "absolute"}  w-full `}>

    <div className="container py-0 px-5  md:px-20 m-auto ">

    <HeaderNav />
    </div>
    </div>
    </>
  );
}

export default Header;


